export default {
  home: {
    minute: "분",
    price_info:
      "최초 {mianfei}분은 무료입니다. 24시간 최대 요금은 {currencyName}{fengding}입니다. 보조배터리는 모든 {appName} 스테이션에서 반납 가능합니다.",
    price_info_0: "USB Type-C 및 Lightning 케이블 포함.",
    price_info_1:
      "보조배터리가 {pOvertimeDay}일 이내에 반납되지 않을 경우, 보증금 금액으로 구매한 것으로 간주됩니다.",
    price_info_2:
      "대여한 장소와 동일한 장소에 반납하는 것을 권장합니다. 앱을 다운로드하거나 보조배터리 뒷면의 QR 코드를 스캔하여 모든 {appName} 설치 장소를 확인하세요.",
    feature_1: "모든 타입 케이블 포함: iPhone, Type-C",
    feature_2: "모든 스테이션에서 반납 가능",
    feature_3: "무선 충전 지원",
    tips_1: "보증금 {currencyName}{yajin}은(는) 대여 종료 시 반환됩니다.",
    tips_2:
      "충전된 보증금 {currencyName}{yajin}은(는) 대여에 사용할 수 있으며, 사용 후 환불 가능합니다.",
    tips_3:
      "현재 잔액은 {currencyName}{myyue}이며, 대여 시 바로 사용할 수 있습니다.",
    submit: "대여 시작",
    borrow: "빌리기",
    msg_fail_title: "오류",
    msg_fail_content: "대여에 실패했습니다. 다시 시도해 주세요.",
    msg_rentcount: "현재 종료되지 않은 주문이 {zujieNum}건 있습니다.",
    goborrow: "충전하러 가기!!!",
    nearby: "주변 스테이션 보기",
    preauth: "사전 승인",
    nearbyvenues: "주변 시설",
    borrow_tips: "신용카드 결제 보안 / 개인정보 처리방침 / 이용 약관",
    company_address:
      "Energo Solar d.o.o Sarajevo Kolodvorska 12 Bosna i Hercegovina",
    company_phone: "(+387)061224 000   (+387)061224 030",
    company_email: "info@solar-shop.ba",
    company_id: "ID 번호: 4203203380006",
    company_vat: "VAT 번호: 203203380006",
    shop_desc_text: "어느 스테이션에서나 반납할 수 있습니다.",
    available_rental: "대여 가능",
    select_battery_type: "배터리 타입을 선택해 주세요.",
    rechargeable_battery: "충전식 배터리",
    fast_charging_battery: "고속 충전 배터리",
    rental_period: "대여 기간",
    usage_fee: "이용 요금",
    standard_powerbank: "일반 보조배터리",
    fast_charge_powerbank: "고속 충전 보조배터리",
    "": ""
  },
  login: {
    welcome: "{appname}에 오신 것을 환영합니다",
    code_title: "인증",
    phone_number: "전화번호",
    verification_email: "이메일 주소를 입력해 주세요",
    verification_code: "인증 번호를 입력해 주세요",
    captcha_code: "코드",
    send_code: "인증 번호 전송",
    login: "로그인",
    agree: "로그인 시 다음 내용에 동의하게 됩니다: ",
    readme: "사용자 동의",
    msg_fail_login: "로그인 실패",
    msg_success_login: "로그인 성공",
    msg_fail_user:
      "사용자 정보를 가져오는데 실패했습니다. 다시 시도하시겠습니까?",
    sign_in_with: "다음으로 로그인:",
    no_sms: "메시지를 받지 못하셨나요?",
    retry: "재전송",
    email: "이메일"
  },
  confirm: {
    deletecard: "카드 삭제",
    addcard: "카드 정보 입력",
    title: "결제 확인",
    paynow: "즉시 결제",
    SMSConfirm:
      "휴대전화로 수신된 메시지에 따라 결제를 진행하고, 확인 버튼을 눌러 계속해 주세요.",
    pay_label: "금액",
    auth_label: "사전 승인",
    price_tips:
      "잔액은 요청 시 인출 가능합니다. 입금 확인까지 영업일 기준 1~5일이 소요될 수 있습니다.",
    auth_tips:
      "사전 승인 금액 {0}{1}은(는) 필수입니다. 실제 대여 요금은 보조배터리 반납 시 차감됩니다.",
    pay_type: "결제 수단을 선택해 주세요",
    submit: "결제 확정",
    msg_loading: "로딩 중...",
    msg_fail_title: "경고",
    msg_fail_payment: "보증금 결제에 실패했습니다",
    msg_fail_order: "대여 주문 생성에 실패했습니다",
    msg_fail_support: "지원되지 않는 시스템입니다",
    msg_fail_confirm: "확인",
    msg_fail_retry: "재시도",
    msg_fail_cancel: "취소"
  },
  mine: {
    title: "사용자 프로필",
    wallet: "내 지갑",
    balance: "잔액",
    deposit: "보증금",
    wallet_in: "충전",
    wallet_out: "인출",
    wallet_log: "지갑 내역",
    rental_history: "대여 내역",
    payment_title: "결제 수단",
    home_title: "홈",
    download_app: "앱 다운로드",
    settings: "설정",
    help: "도움말",
    logout: "로그아웃",
    login_tips: "로그인해 주세요",
    msg_fail_title: "오류",
    msg_fail_update: "변경에 실패했습니다. 다시 시도해 주세요.",
    msg_loading: "로딩 중...",
    msg_fail_user:
      "사용자 정보를 가져오는데 실패했습니다. 다시 시도하시겠습니까?",
    edit_profile: "프로필 수정",
    join_us: "가맹점 모집",
    join_us_details: "매장에 Blitz 스테이션을 설치하세요"
  },
  msg: {
    appoffline: "앱이 아직 실행되지 않았습니다. 잠시만 기다려 주세요.",
    deletecard: "정말로 이 카드를 삭제하시겠습니까?",
    no_phone: "전화번호는 필수입니다",
    loading: "로딩 중...",
    title: "알림",
    success: "작업 성공",
    error: "알 수 없는 오류가 발생했습니다. 나중에 다시 시도해 주세요",
    roleerror: "권한이 부족합니다. 관리자에게 문의하세요.",
    neterror: "네트워크 연결에 실패했습니다. 나중에 다시 시도해 주세요",
    confirm: "확인",
    retry: "재시도",
    cancel: "취소",
    title_fail: "경고",
    vieworder: "주문 보기",
    success_payment: "결제 완료",
    success_buy: "구매 완료",
    fail_payment: "결제 실패",
    keyword: "키워드",
    ispayorder: "결제가 완료되었는지 확인해 주세요",
    unpay: "미결제",
    yespay: "결제 완료",
    notopen: "오픈 전"
  },
  result: {
    tips: "주문 확인 및 다른 스테이션 위치를 보려면 앱을 다운로드하세요.",
    download: "앱 다운로드",
    title: "대여 확정",
    gotit: "확인",
    price_plan: "요금제",
    msg_success: "대여 성공",
    msg_tips_loading: "보조배터리가 나오고 있습니다. 잠시만 기다려 주세요...",
    msg_result_loading: "결제 결과를 확인 중입니다...",
    msg_fail_confirm: "확인",
    btn_usage: "사용 시 주의사항",
    btn_return: "반납 시 주의사항",
    deposit: "보증금",
    msg_fail_content: "요청에 실패했습니다. 다시 시도해 주세요.",
    price_label: "시간당",
    price_info:
      "최초 {mianfei}분 무료. 1일 최대 요금 {ccurrency}{fengding}. 이용료가 {ccurrency}{yajin}에 도달하면 보증금에서 자동 차감됩니다.",
    tips_1: "사진과 같이 No.{number} 보조배터리를 가져가세요.",
    tips_2:
      "케이블을 정리하고 [아래 화살표] 표시가 있는 면을 슬롯에 삽입하세요.",
    msg_note_usage:
      "이 보조배터리에는 3가지 타입의 케이블이 장착되어 있습니다. 기기에 맞는 것을 선택해 주세요.",
    msg_note_return:
      "케이블을 정리하고 [아래 화살표] 표시가 있는 면을 슬롯에 삽입하세요.",
    return_info:
      "반납 시에는 케이블을 깔끔하게 정리하고, 금속 칩이 있는 면을 빈 슬롯 바닥까지 닿도록 끝까지 밀어 넣어주세요.",
    download_tips: "보조배터리를 대여하려면 다음 옵션 중 하나를 선택하세요."
  },
  result_msg: {
    loading: "로딩 중...",
    refresh: "새로고침"
  },
  order: {
    title: "대여 내역",
    in_use: "사용 중",
    ended: "종료됨",
    msg_error: "요청 실패",
    order_number: "No.",
    order_details: "주문 상세",
    order_zj_shop: "대여 장소",
    order_zj_time: "대여 시간",
    order_gh_shop: "반납 장소",
    order_gh_time: "반납 시간",
    order_use_time: "이용 시간",
    order_amount: "총 금액",
    not_on_rent: "대여 안 함",
    renting: "대여 중",
    undone: "미완료",
    returned: "반납 완료",
    questions: "문의하기",
    timeout_to_return: "반납 기한 초과",
    suspended_for_billing: "청구 일시 중지"
  },
  order_item: {
    order_number: "No.",
    venue_rented: "대여 장소",
    time_rented: "대여 시간",
    venue_returned: "반납 장소",
    time_returned: "반납 시간",
    charge_standard: "요금 기준",
    charge_standard_info: "시간당 {pJifei} {pCurrency} (최초 {pMian}분 무료)",
    rent_occurred: "대여 발생",
    returned: "반납 완료",
    unreturned: "미반납",
    type_0: "미완료",
    type_1: "대여 중",
    type_2: "취소됨",
    type_3: "반납 완료",
    type_4: "오류 발생",
    type_5: "시간 초과",
    min: "분",
    payment: "결제",
    unpay: "미결제"
  },
  setting: {
    title: "설정",
    lang: "언어"
  },
  help: {
    title: "자주 묻는 질문",
    rentals: "대여 관련",
    venues: "장소 관련",
    payments: "결제 관련"
  },
  wallet_in: {
    title: "잔액 충전",
    price_label: "충전 금액",
    price_placeholder: "충전할 금액을 입력하세요",
    balance: "현재 잔액",
    price_auto: "결제 금액 선택",
    price_tips:
      "잔액은 요청 시 인출 가능합니다. 입금 확인까지 영업일 기준 1~5일이 소요될 수 있습니다.",
    submit: "제출",
    loading: "로딩 중...",
    paying: "결제 페이지로 이동 중...",
    msg_title: "알림",
    msg_fail_order: "충전 주문 생성에 실패했습니다",
    msg_fail_payment: "충전 결제 시작에 실패했습니다",
    msg_fail_retry: "재시도"
  },
  wallet_out: {
    title: "인출",
    price_label: "인출 금액",
    price_placeholder: "인출할 금액을 입력하세요",
    balance: "현재 잔액",
    balance_all: "전액 인출",
    deposit: "보증금",
    deposit_tips:
      "미완료된 대여 주문이 있습니다. 보증금 Ksh{pyajin}은(는) 환불되지 않습니다.",
    submit: "제출",
    apply: "신청",
    confirm: "확인",
    loading: "로딩 중...",
    msg_fail_price: "인출 금액이 올바르지 않습니다",
    msg_fail_balance: "인출 금액은 현재 잔액을 초과할 수 없습니다",
    msg_fail_submit: "필수 항목을 모두 입력해 주세요",
    msg_title: "오류",
    msg_success_content: "환불 성공",
    confirmtitle: "알림",
    confirmcontent:
      "현재 지갑은 현금 인출을 지원하지 않습니다. 수동 환불 처리를 위해 연락처 정보를 입력해 주세요.",
    payee_name: "예금주",
    payee_bankcard: "계좌 번호",
    payee_phone: "전화번호",
    cancelText: "취소",
    confirmText: "재신청"
  },
  map: {
    在线: "영업 중",
    离线: "영업 종료",
    title: "주변 스테이션",
    result_msg: "주변에 스테이션이 없습니다",
    msg_title: "오류",
    no_support:
      "죄송합니다! 현재 브라우저는 위치 정보 서비스를 지원하지 않습니다",
    my_position: "내 위치",
    distance: "거리:",
    shop_time: "영업 시간",
    free: "대여 가능",
    return: "반납 가능",
    shop_title: "시설 상세",
    address: "주소",
    go_here: "길찾기",
    nav_help: "도움말",
    nav_search: "검색",
    locate: "위치 확인",
    history: "이력",
    account: "내 계정",
    scan: "스캔"
  },
  scanQr: {
    NotAllowedError: "카메라 접근 권한을 허용해야 합니다",
    NotFoundError: "이 기기에는 카메라가 없습니다",
    NotSupportedError: "보안 컨텍스트가 필요합니다 (HTTPS, localhost)",
    NotReadableError: "카메라가 사용 중입니다",
    OverconstrainedError: "카메라 설치가 적절하지 않습니다",
    StreamApiNotSupportedError: "이 브라우저는 스트리밍 API를 지원하지 않습니다"
  },
  payment: {
    payment_title: "결제 수단",
    pay_type: "카드 정보를 추가해 주세요",
    add_payment_card: "결제 카드 추가",
    add_payment: "결제 수단 추가"
  },
  shop: {
    title: "주변 스테이션",
    search_station: "스테이션 검색",
    search_station_tips: "스테이션 이름을 입력하세요",
    shop_power_banks: "보조배터리",
    shop_empty_slots: "빈 슬롯",
    shop_address: "주소",
    shop_business_hours: "영업 시간",
    shop_directions_station: "스테이션 가는 길",
    shop_scan_qrcode: "QR 코드 스캔",
    fast_charging_power_banks: "고속 충전 보조배터리",
    ordinary_power_bank: "일반 보조배터리",
    returnable: "반납 가능"
  },
  time: {
    days: "일",
    hours: "시간",
    minutes: "분"
  }
};
